import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Menu, X } from 'lucide-react';
import { LogoHome } from './LogoHome';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_e3b3c70d-c72e-49dc-b41a-da6affdc6e46/artifacts/4w4rfom9_IMG_0777.PNG";

export function MobileNav({ navItems, user, onLogout }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Mobile Header */}
      <div className="lg:hidden fixed top-0 left-0 right-0 h-14 bg-slate-950 border-b border-slate-800 z-50 flex items-center justify-between px-4">
        <LogoHome className="h-8 w-auto" />
        <Button variant="ghost" size="sm" onClick={() => setOpen(!open)} className="text-white p-1" data-testid="mobile-menu-btn">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </Button>
      </div>

      {/* Mobile Drawer */}
      {open && (
        <div className="lg:hidden fixed inset-0 z-40" data-testid="mobile-nav-drawer">
          <div className="absolute inset-0 bg-black/60" onClick={() => setOpen(false)} />
          <div className="absolute top-14 left-0 right-0 bottom-0 bg-slate-950 overflow-y-auto">
            <nav className="p-4 space-y-1">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                    item.active
                      ? 'bg-slate-800 text-white'
                      : 'text-slate-400 hover:bg-slate-800 hover:text-white'
                  }`}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {item.icon}
                  {item.label}
                </Link>
              ))}
            </nav>
            <div className="p-4 border-t border-slate-800">
              <div className="flex items-center gap-3 mb-4">
                <div className="h-10 w-10 rounded-full bg-teal-600 flex items-center justify-center text-white font-medium">
                  {user?.name?.charAt(0)}
                </div>
                <div>
                  <p className="text-white font-medium text-sm">{user?.name}</p>
                  <p className="text-slate-500 text-xs capitalize">{user?.role}</p>
                </div>
              </div>
              <Button variant="outline" size="sm" className="w-full border-slate-700 text-slate-300 hover:bg-slate-800" onClick={onLogout}>
                Logout
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Spacer for mobile header */}
      <div className="lg:hidden h-14" />
    </>
  );
}
